<h1 mat-dialog-title>Layout Settings</h1>
<div mat-dialog-content>
  <form class="standard-form">
    <mat-form-field>
      <mat-label>Layout Name</mat-label>
      <input matInput name="result.podLayout.name" [(ngModel)]="result.podLayout.name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Bookmark</mat-label>
      <mat-select name="selectedBookmarkId" [(value)]="selectedBookmarkId" (change)="selectedBookmarkChanged()">
        <mat-option [value]="-1">Use Current Report State</mat-option>
        <mat-option *ngFor="let bookmark of data.bookmarks" [value]="bookmark.bookmarkId">
          {{bookmark.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="selectedBookmarkId === -1">
      <mat-label>Subscription</mat-label>
      <mat-select [(value)]="selectedSubscriptionId">
        <mat-option *ngFor="let subHeader of data.availableSubscriptions" [value]="subHeader.subscriptionId">
          {{ subHeader.subscriptionName }} - {{ subHeader.organizationName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>File Type</mat-label>
      <mat-select name="result.podLayout.fileTypeId" [(ngModel)]="result.podLayout.fileTypeId">
        <mat-option [value]="0">PDF</mat-option>
        <mat-option [value]="1">PPTX</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container>
      <mat-label>Pages To Print</mat-label>
      <mat-selection-list #selectionList (selectionChange)="onSelectionChange($event)">
        <mat-list-option *ngFor="let page of data.pages" [value]="page" [selected]="isOptionSelected(page)">
          {{page.displayName}}
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
  </form>
  <app-share-editor *ngIf="isOwner" allowReadOnly="true" allowModify="true" [(ngModel)]="shareState" [avaialbleSubscriptions]="data.availableSubscriptions"></app-share-editor>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onPreviewLayout()">Modify Layout Pages</button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>
</div>
